/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 * @author Julia Ignatieva
 * @version 1.15.0
 * @since 1.15.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const CloseInquiryContainerStyled = styled.div.attrs({
    'className': 'close-inquiry',
    'data-footer-close-inquiry': 'close-inquiry',
})`
    width: 600px;
    box-sizing: border-box;
    padding: 24px 0;
    & .close-inquiry__search,
    & .close-inquiry__footer {
        box-sizing: border-box;
    }

    & .close-inquiry__footer {
        padding: 24px 24px 0;
    }

    & .close-inquiry__search {
       padding: 0 24px;
    }
`;

export const CloseInquiryHeaderStyled = styled.div.attrs({
    className: 'close-inquiry__header',
})`
    padding: 0 24px 24px;
    box-sizing: border-box;
`;

export const CloseInquiryTitleStyled = styled.span.attrs({
    className: 'close-inquiry__title',
})`
    display: block;
    ${fonts.textHeader3};
    margin-bottom: 4px;
`;

export const CloseInquiryInfoStyled = styled.span.attrs({
    className: 'close-inquiry__info',
})``;

export const CloseInquiryFooterStyled = styled.div.attrs({
    'className': 'close-inquiry__footer',
    'data-label-close-inquiry': 'close-inquiry-footer',
})`
    display: flex;
    align-items: center;
    & .close-inquiry__footer-link {
        margin-left: 16px;
    }
`;

export const CloseInquiryNoteStyled = styled.div.attrs({
    className: 'close-inquiry__note',
})`
    padding: 24px;
    max-height: 325px;
    overflow-y: auto;
    background-color: ${colors.createInquiryFieldBg};

    & textarea {
        padding: 12px 20px;
        min-height: 96px;
        box-sizing: border-box;
        ${fonts.textMain};
        outline: none;
    }
`;
